<template>
    <b-form :save-url="addUrl" @success="formSuccess" v-slot="{model, loading}" @failure="formFailure"
            :initial-data="initialData"
            :save-params="{api_key: currentUser.api_key, description : JSON.stringify(description)}">

        <div class="row m-1">
            <validated-input class="col-6" label="Title" v-model="model.title"
                             :rules="{required:true}" :disabled="loading"/>

            <filee-input
    ref="imageInput"
    class="c-file-input col-6"
    label="Image"
    v-model="model.image"
    :disabled="loading"
    @input="validateImage($event, model)"
/>
        </div>
        <div class="row m-1">
            <div class="col">
                <image-info :width="1004" :height="480"/>
            </div>
        </div>

        <div class="row m-1">
            <validated-textarea class="col-12" label="Title Description" v-model="model.title_description"
                                :rules="{required:true, min:250, max : 1000}" :disabled="loading"/>

        </div>
        <div class="col-12 fl-eqh-r mb-1">
            <div class="btn-group">
                <btn @click="addItem('h')" type="button" size="xs" text="Heading" :disabled="loading"/>
                <btn @click="addItem('d')" type="button" size="xs" text="Description" :disabled="loading"/>
                <btn @click="addItem('b')" type="button" size="xs" text="Bullets" :disabled="loading"/>
                <btn @click="clearAll" type="button" size="xs" text="Clear All" :disabled="loading"/>
            </div>
        </div>
        <div class="col-12">
            <div v-for="(i, index) in description" :key="index">
                <div v-if="i.type==='h'" class="fl-te-c mb-1 mt-3">
                    <label>Heading</label>
                    <btn color="danger" @click="deleteItem(index)" type="button" size="xs"
                         icon="fa fa-trash" :disabled="loading"/>
                </div>
                <validated-input v-if="i.type==='h'" name="Heading" v-model="i.value"
                                 :rules="{required:false}" :disabled="loading" class="mb-1"/>
                <div v-if="i.type==='d'" class="fl-te-c mb-1 mt-3">
                    <label>Description</label>
                    <btn color="danger" @click="deleteItem(index)" type="button" size="xs"
                         icon="fa fa-trash" :disabled="loading"/>
                </div>
                <validated-textarea v-if="i.type==='d'" v-model="i.value"
                                    :rules="{required:false}" :disabled="loading" class="mb-1"/>
                <div v-if="i.type==='b'" class="b-1 round-2 p-1 mt-3">
                    <div class="fl-eqh-r m-1">
                        <div class="btn-group">
                            <btn color="danger" @click="deleteItem(index)" type="button" size="xs"
                                 icon="fa fa-trash" text="Delete All" :disabled="loading"/>
                            <btn @click="addPoint(index)" type="button" size="xs" text="Add Point" :disabled="loading"/>
                        </div>
                    </div>
                    <div class="m-1" v-for="(j, ind) in i.value" :key="ind">
                        <div class="fl-te-c mb-1 mt-3">
                            <label>Point</label>
                            <btn color="danger" @click="deletePoint(index, ind)" type="button" size="xs"
                                 icon="fa fa-trash" :disabled="loading"/>
                        </div>
                        <validated-input name="Point" v-model="j.value"
                                         :rules="{required:false}" :disabled="loading"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 mt-2">
            <btn class="trn" size="sm" :loading="loading" color="primary" text="Update"
                 loading-text="Updating..." :disabled="loading"/>
        </div>
    </b-form>
</template>

<script>
import urls from '../../../../data/urls';
import { mapGetters } from 'vuex';

export default {
    name     : 'EditService',
    props    : { initialData : { type : Object } },
    computed : { ...mapGetters(['currentUser']) },
    data () {
        return {
            addUrl      : urls.admin.event.service.addEdit,
            description : []
        };
    },
    mounted () {
        this.setData();
    },
    methods : {
        validateImage (files, model) {
            if (!files || files.length === 0) {
                return;
            }
            const file = files[0];
            const image = new Image();
            image.onload = () => {
                URL.revokeObjectURL(image.src);
                if (image.width !== 1004 || image.height !== 480) {
                    this.$notify(
                        'Please upload an image with dimensions 1004 × 480 pixels.',
                        'Invalid Image',
                        {
                            type : 'warning'
                        }
                    );
                    // Clear file input
                    this.$refs.imageInput.text = '';
                    this.$refs.imageInput.files = [];

                    // Clear model
                    model.image = [];
                    return;
                }
                // Valid image
                model.image = files;
            };

            image.onerror = () => {
                URL.revokeObjectURL(image.src);

                this.$notify(
                    'Unable to read the selected image.',
                    'Invalid Image',
                    {
                        type : 'warning'
                    }
                );

                this.$refs.imageInput.text = '';
                this.$refs.imageInput.files = [];
                model.image = [];
            };

            image.src = URL.createObjectURL(file);
        },
        viewFile (url) {
            window.open(url);
        },
        setData () {
            this.description = [...JSON.parse(this.initialData.initial_description)];
        },
        addItem (type) {
            if (type === 'b') {
                this.description.push({ id : 'Item', type : type, value : [{ id : 'Point', value : '' }] });
            } else {
                this.description.push({ id : 'Item', type : type, value : '' });
            }
        },
        addPoint (index) {
            this.description[index].value.push({ id : 'Item', value : '' });
        },
        deleteItem (index) {
            this.description.splice(index, 1);
        },
        deletePoint (index, pointIndex) {
            this.description[index].value.splice(pointIndex, 1);
        },
        clearAll () {
            this.description = [];
        },
        formSuccess () {
            this.$notify('Successfully Edited Event Service..!', 'Success',
                {
                    type : 'success'
                }
            );
            this.$emit('success');
        },

        formFailure (response) {
            const json = response.data;
            if (json.permission === false) {
                this.$notify('Invalid Authentication..!', 'Permission Denied',
                    {
                        type : 'warning'
                    }
                );
            }
        }
    }
};
</script>

<style scoped>

</style>
